import { cacheFor } from '@ember/object/internals';
export default function notifyChanges(identifier, value, record, store) {
  if (value === 'attributes') {
    record.eachAttribute(key => {
      var currentValue = cacheFor(record, key);
      var internalModel = store._internalModelForResource(identifier);
      if (currentValue !== internalModel._recordData.getAttr(key)) {
        record.notifyPropertyChange(key);
      }
    });
  } else if (value === 'relationships') {
    record.eachRelationship((key, meta) => {
      var internalModel = store._internalModelForResource(identifier);
      if (meta.kind === 'belongsTo') {
        record.notifyPropertyChange(key);
      } else if (meta.kind === 'hasMany') {
        if (meta.options.async) {
          record.notifyPropertyChange(key);
          internalModel.hasManyRemovalCheck(key);
        }
        if (internalModel._manyArrayCache[key]) {
          internalModel._manyArrayCache[key].retrieveLatest();
        }
      }
    });
  } else if (value === 'errors') {
    var internalModel = store._internalModelForResource(identifier);
    //TODO guard
    var errors = internalModel._recordData.getErrors(identifier);
    record.invalidErrorsChanged(errors);
  } else if (value === 'state') {
    record.notifyPropertyChange('isNew');
    record.notifyPropertyChange('isDeleted');
  } else if (value === 'identity') {
    record.notifyPropertyChange('id');
  }
}